import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import Testimonial from '@segment/templates/Testimonial'

const link = {
  text: `Apply to Twilio Segment`,
  url: `https://airtable.com/shrvZzQ6NTTwsc6rQ`,
}

const TestimonialSection = () => {
  return (
    <StyledSection variant="noCopy">
      <StyledSectionContents>
        <Testimonial company="candu" />
        <ButtonWrapper>
          <Button tag="a" href={link.url} size="large" color="primary" variant="filled">
            {link.text}
          </Button>
        </ButtonWrapper>
      </StyledSectionContents>
    </StyledSection>
  )
}

const StyledSection = styled(SectionBase)`
  max-width: 1060px;
`

const StyledSectionContents = styled(Section.Contents)`
  display: grid;
  justify-content: center;
`

const ButtonWrapper = styled.div`
  display: none;
  justify-content: center;
  margin-top: 80px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    display: flex;
  }
`

export default TestimonialSection
